export const SET_ORDERS = 'SUPPORT/SET_ORDERS';
export const SET_ORDER = 'SUPPORT/SET_ORDER';
export const SET_LOADING = 'SUPPORT/SET_LOADING';
export const SET_ERROR = 'SUPPORT/SET_ERROR';

export const SET_BANK_ACCOUNT_ORDERS = 'SUPPORT/SET_BANK_ACCOUNT_ORDERS';
export const SET_BANK_ACCOUNT_ORDER = 'SUPPORT/SET_BANK_ACCOUNT_ORDER';
